import { ApiClient } from './base/apiClient';
import type { ApiResponse } from '~/types/api/common/apiResponse';
import type { QrLoginResponse } from '~/types/api/auth/qrLogin';
import type { GetCsrfTokenResponse } from '~/types/api/auth/getCsrfToken';
import type { LoginRequest, LoginResponse } from '~/types/api/auth/login';
import type { GetSessionInfoResponse } from '~/types/api/auth/getSessionInfo';

const BASE_PATH = '/auth';

/**
 * 認証系リポジトリ
 */
export class AuthRepository {
  private apiClient: ApiClient;

  constructor(displayId: string) {
    this.apiClient = new ApiClient(displayId);
  }

  /**
   * [sp-api-001] QRログインAPI
   *
   * @param qrcode QRコード
   * @returns QRログインAPIレスポンス
   */
  async qrLogin(qrcode: string): Promise<ApiResponse<QrLoginResponse>> {
    return await this.apiClient.post<QrLoginResponse>(BASE_PATH + '/qr_login', {
      qrcode,
    });
  };

  /**
   * [sp-api-002] ログアウトAPI
   *
   * @returns ログアウトAPIレスポンス
   */
  async logout(): Promise<ApiResponse<void>> {
    return await this.apiClient.post(BASE_PATH + '/logout');
  };

  /**
   * [sp-api-003] セッション有効性チェックAPI
   *
   * HTTPステータスが200ならOK
   */
  async checkSession(): Promise<void> {
    await this.apiClient.post(BASE_PATH + '/session');
  };

  /**
   * [sp-api-004] CSRFトークン取得API（CSRFトークンは`X-XSRF-TOKEN`ヘッダに保存される）
   *
   * @returns CSRFトークン情報
   */
  async getCsrfToken(): Promise<ApiResponse<GetCsrfTokenResponse>> {
    return await this.apiClient.get<GetCsrfTokenResponse>(BASE_PATH + '/csrf');
  };

  /**
   * [sp-api-005] ログインAPI
   *
   * @param request ログインAPIリクエスト
   * @returns ログインユーザ情報
   */
  async login(request: LoginRequest): Promise<ApiResponse<LoginResponse>> {
    return await this.apiClient.post<LoginResponse>(BASE_PATH + '/login', request);
  };

  /**
   * [sp-api-007] セッション情報取得API
   *
   * @returns ログイン中のユーザ情報
   */
  async getSessionInfo(): Promise<ApiResponse<GetSessionInfoResponse>> {
    return await this.apiClient.get<GetSessionInfoResponse>(BASE_PATH + '/me');
  };
};
